import { useFormProductVariantId } from '@/features/pos/components/ProductConfigurationModal/form'
import { ProductVariant } from '@/features/pos/components/ProductConfigurationModal/types'

export const useSelectedProductVariant = (productVariants: ProductVariant[]) => {
    const [productVariantId] = useFormProductVariantId()

    return productVariants.find(({ id }) => id === productVariantId)
}
